/* src/services/OpeningHoursService.js */
import apiClient from './api'

export const OpeningHoursService = {

  // --- ORARI SETTIMANALI ---
  mapWeeklyFromApi(data) {

    const giorniSettimana = ['Lunedì', 'Martedì', 'Mercoledì', 'Giovedì', 'Venerdì', 'Sabato', 'Domenica']
    const parsedSlots = (data.slots || []).map(s => ({
      id: s.id,
      start: s.start_time ? s.start_time.substring(0, 5) : '09:00',
      end: s.end_time ? s.end_time.substring(0, 5) : '18:00'
    }))

    return {
      id: data.id,
      dayIndex: data.day,
      name: data.day_display || giorniSettimana[data.day] || 'Giorno',
      isOpen: !!data.is_active,
      slots: parsedSlots
    }
  },

  async getAllWeekly() {

    try {

      const response = await apiClient.get('booking/weekly-hours/')
      return (response.data || []).map(item => this.mapWeeklyFromApi(item))
    } 
    catch (error) {

      console.error("Errore nel recupero orari:", error)
      throw error
    }
  },

  async updateWeekly(data) {
    const response = await apiClient.put('booking/weekly-hours/', data)
    return response.data
  },

  // --- CHIUSURE ---
  mapClosureFromApi(data) {

    return {
      id: data.id,
      occasione: data.name || data.reason || '',
      data: data.date || '',
      isFullDay: !!data.all_day,
      start: data.start_time ? data.start_time.substring(0, 5) : '09:00',
      end: data.end_time ? data.end_time.substring(0, 5) : '18:00'
    }
  },

  async getAllClosures() {

    const response = await apiClient.get('booking/extraordinary-closures/')
    return (response.data || []).map(item => this.mapClosureFromApi(item))
  },

  async createClosure(closure) {

    const response = await apiClient.post('booking/extraordinary-closures/', closure)
    return this.mapClosureFromApi(response.data)
  },

  async updateClosure(id, closure) {

    const response = await apiClient.put(`booking/extraordinary-closures/${id}/`, closure)
    return this.mapClosureFromApi(response.data)
  },

  async deleteClosure(id) {

    return await apiClient.delete(`booking/extraordinary-closures/${id}/`)
  }
}